import { Component, inject, OnInit, Type, ViewChild } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { AppLayoutService } from '../../app-layout.service';
import { BarChartSquare02 } from '../../../../../shared/icons/bar-chart-square-02/bar-chart-square-02';
import { Cube01 } from '../../../../../shared/icons/cube-01/cube-01';
import { CalendarCheck01 } from '../../../../../shared/icons/calendar-check-01/calendar-check-01';
import { Users01 } from '../../../../../shared/icons/users-01/users-01';
import { DynamicIconComponent } from '../../../../../shared/ui/dynamic-icon/dynamic-icon';
import { Settings01 } from '../../../../../shared/icons/settings-01/settings-01';
import { UserService } from '../../../../../shared/services/user.service';
import { getInitials } from '../../../../../shared/functions/functions';
import { Menu } from 'primeng/menu';
import { MenuItem } from 'primeng/api';
import { AuthService } from '../../../../../shared/services/auth.service';
import { Router } from '@angular/router';

export interface NavItem {
  label: string;
  route: string;
  badge?: number;
  iconComponent: Type<any>;
}

export interface MenuGroup {
  title: string;
  items: NavItem[];
}

@Component({
  standalone: true,
  selector: 'app-menu-sidebar',
  imports: [RouterLink, RouterLinkActive, DynamicIconComponent, Settings01, Menu],
  templateUrl: './menu-sidebar.html',
  styleUrl: './menu-sidebar.scss',
})
export class MenuSidebar implements OnInit {
  @ViewChild('userCardMenu') userCardMenu!: Menu;

  sidebarService = inject(AppLayoutService);
  userService = inject(UserService);
  authService = inject(AuthService);
  private router = inject(Router);
  hoveredRoute: string | null = null;
  name: string | undefined;

  ngOnInit() {
    const { fullName, email } = this.userService.getUserData;
    this.name = fullName?.length ? fullName : email?.split('@')[0] || 'Admin';
  }

  menuGroups: MenuGroup[] = [
    {
      title: 'PREGLED',
      items: [
        { label: 'Kontrolna tabla', route: '/admin/dashboard', iconComponent: BarChartSquare02 },
      ],
    },
    {
      title: 'PROCESI',
      items: [
        { label: 'Zahtevi za kupovinu', iconComponent: Cube01, route: '/admin/packages' },
        { label: 'Rezervacije', iconComponent: CalendarCheck01, route: '/admin/appointments' },
      ],
    },
    {
      title: 'KLIJENTI',
      items: [{ label: 'Klijenti', iconComponent: Users01, route: '/admin/clients' }],
    },
  ];

  userCardMenuItems: MenuItem[] = [
    {
      label: 'Moj profil',
      icon: 'pi pi-user',
      command: () => this.router.navigateByUrl('/admin/profile'),
    },
    {
      label: 'Odjavi se',
      className: 'hover:text-red-600',
      icon: 'pi pi-sign-out',
      command: () => this.authService.logout(),
    },
  ];

  toggleUserCardMenu(event: MouseEvent) {
    this.userCardMenu.toggle(event);
  }

  onMenuItemClick(): void {
    if (this.sidebarService.isMobile()) {
      this.sidebarService.isDrawerVisible.set(false);
    }
  }

  protected readonly getInitials = getInitials;
}
